import { render, staticRenderFns } from "./ConsumerProfileEditForm.vue?vue&type=template&id=4ef45833&scoped=true&"
import script from "./ConsumerProfileEditForm.vue?vue&type=script&lang=js&"
export * from "./ConsumerProfileEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerProfileEditForm.vue?vue&type=style&index=0&id=4ef45833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef45833",
  null
  
)

export default component.exports